import { FiChevronDown } from 'react-icons/fi';

import styled, { css, ThemeColors } from 'styled-components';

interface ICollapseArrow {
  readonly open: boolean;
  readonly size?: number;
  color?: ThemeColors;
  disabled?: boolean;
}

export const CollapseArrow = styled(FiChevronDown)<ICollapseArrow>`
  transition: 0.25s !important;
  min-height: ${({ size }) => `${size || 20}px`};
  max-height: ${({ size }) => `${size || 20}px`};
  min-width: ${({ size }) => `${size || 20}px`};
  max-width: ${({ size }) => `${size || 20}px`};

  ${({ color }) =>
    color &&
    css`
      color: ${({ theme }) => theme.colors[color]};
    `}

  ${({ open }) =>
    open &&
    css`
      transform: rotate(180deg);
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.colors.darkGray};
    `}
`;
